<template>
<b-row>
   <b-col cols="12" xl="12"> 
      <b-card>
        <b-form @submit.prevent="dealerAdd">
          <b-row>
            <b-col sm="12" md="6">
                <b-form-group label="*Name:" label-for="name">
                    <b-form-input maxlength="40" :class="{ 'is-invalid' : $v.form.name.$error }" id="name" v-model="$v.form.name.$model" type="text" class="form-control" placeholder="Enter Dealer Name"  aria-describedby="dealernameField" />
                    <b-form-invalid-feedback id="dealernameField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group label="Status">
                <b-form-radio-group v-model="form.status" :options="statusItems" name="radioOpenions">
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
             <b-col sm="12" md="6">
                <b-form-group label="*Select Owner:" label-for="onwerTypeField">
                  <b-form-select  :class="{ 'is-invalid' : $v.form.user_id.$error }"  v-model="$v.form.user_id.$model" :options="userTypeItems"  id="onwerTypeField"  aria-describedby="onwerTypeField" />    
                  <b-form-invalid-feedback id="onwerTypeField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
            <b-col sm="12" md="4">
                <b-form-group label="Logo Image: (Only jpg,jpeg,png and gif ext allowed.)" label-for="orglogoimgField">
                  <b-form-file ref="dealerLImag" @change="onFileChange"  id="dealerlogoimgField" accept=".jpg, .jpeg, .png" placeholder="Choose a file..."></b-form-file>
                </b-form-group>  
            </b-col>
            <b-col sm="12" md="2" v-if="previewSImage">
                <b-form-group label="Image Preview:">
                  <b-img :src="previewSImage" width="150" height="50" alt="Image Preview" />
                </b-form-group> 
            </b-col>  
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-button type="button" v-b-tooltip.hover title="Cancel" variant="secondary" @click.stop="gotolist()"  class="px-4">Cancel</b-button>
              <b-button type="submit" v-b-tooltip.hover title="Save" variant="primary"  class="px-4 pull-right">Save</b-button> 
            </b-col>
          </b-row>
        </b-form>
      </b-card>
  </b-col>
</b-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'  
import { validationMixin } from 'vuelidate';  
import { required, maxLength } from 'vuelidate/lib/validators';
import { getResponseMessages } from '../../_helpers';
export default {
  name: 'Dealer_Add',
  data() {
    return {
      userTypeItems: [{
        text: 'Please select Owner',
        value: '',
      }],
      form: {
        name:'',
        status:0,
        image:'',
        user_id:''
      },
      fileOnjk:'',
      statusItems: [
        { text: 'Active', value: 0 },
        { text: 'Inactive', value: 1 }
      ],
      previewSImage:''
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(40)
      },
      user_id: {
        required
      }
    }  
  },
  created(){
    this.loadUserData();
    if(this.$route.params.id != undefined){
      this.getDealerById(this.$route.params.id)
    }
  },  
  methods: {
     ...mapActions('org', ['getById','uploadData']),
    dealerAdd() {
      this.$v.form.$touch();
      if(this.$v.form.$error) return
      const formData = new FormData();
      const formObj = Object.assign({}, this.form);
      formData.append('logoimage', this.fileOnjk) 
      Object.keys(formObj).map(function(key){ 
          formData.append(key, formObj[key])  
      });
      this.$store.dispatch('uploadData',{url:'dealer/saveDealer',data: formData}).then((res) => { 
        this.$toastr('success', getResponseMessages(res.data.messages), 'Success')
        // Update Default Container dealer array
        this.$parent.dealerItems = [];
        this.$parent.loadDealerData();
        // Update Default Container dealer array
        this.$router.push('/dealer')
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    gotolist () {
      this.$router.push('/dealer/list')
    },
    getDealerById(id) {
      this.$store.dispatch('getById', {url:'dealer/getDealerById',data : { 'dealerId':id }}).then((res) => {
        this.form = Object.assign({}, res)  
        this.previewSImage = res.image;
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    loadUserData() {
      var dealerId= 0;
      if(this.$route.params.id != undefined){
        dealerId = this.$route.params.id
      }
      this.$store.dispatch('getById', {url:'dealer/loadUserData',data :{dealer:dealerId}}).then((res) => {
        if(Array.isArray(res.user)){
          res.user.forEach((version) => {
            this.userTypeItems.push(version);
          });
        }
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    onFileChange(e) {
      this.fileOnjk = e.target.files[0]
      if(this.fileOnjk.type == 'image/jpeg' || this.fileOnjk.type == 'image/jpg' || this.fileOnjk.type == 'image/png'){
        this.previewSImage = URL.createObjectURL(e.target.files[0]);
      }else{
        this.fileOnjk = '';
        this.$refs.dealerLImag.value = '';
        // document.getElementById('dealerlogoimgField__BV_file_control_').innerHTML = 'Choose a file...';
        this.$toastr('error','Only jpg,jpeg and png ext are allowed.', 'Error')
      }
      
    }
  }
}
</script>
